module.exports = __webpack_public_path__ + "static/media/Rajas con crema.aebc5bf2.jpg";